import { useLocalizedString } from '@volvo-cars/react-locale-provider';
import { label as labelTranslations } from '../../i18n/next/i18n';
import { IconButton, type LocalizedIconButtonProps } from '../icon-button';

/**
 * A button for navigating to the next item, page, or step.
 * Uses the useLocale hook from LocaleProvider context to provide an accessible label
 * based on the current locale, or wraps with one if `locale` is provided.
 */
export function NextIconButton(props: LocalizedIconButtonProps) {
  const label = useLocalizedString(labelTranslations);
  return <IconButton icon="chevron-forward" aria-label={label} {...props} />;
}
